/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import apiClient from "../../../../apiClient";
import DataTable from "react-data-table-component";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Edit } from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import EditPage from "../components/EditCMS";
import "../../../styles.css";

const FetchTableData = ({ onRefresh }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState(null);

  const [open, setOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [severity, setSeverity] = useState("success");

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    setSnackbarOpen(true);
    setRefresh(!refresh);
    setSnackbarMsg("CMS created successfully!!");
    setSeverity("success");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleFailed = (msg) => {
    setSnackbarMsg(msg);
    setRefresh(!refresh);
    setSnackbarOpen(true);
    setSeverity("error");
  };

  // Fetch data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/cms");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching cms data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [onRefresh]);

  // Open the confirmation dialog
  const handleEditClick = (data) => {
    setEditData(data);
    setOpenDialog(true);
    setOpen(true);
  };

  // Close the confirmation dialog without deleting
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditData(null);
  };

  // Handle delete action
  // const handleConfirmDelete = () => {
  //   try {
  //     apiClient.delete(`/admin/deleteFAQ/${deleteId}`).then((response) => {
  //       if (response.status === 200) {
  //         handleCloseDialog();
  //         fetchData();
  //       }
  //     });
  //   } catch (error) {
  //     console.error("Error deleting faq:", error);
  //   }
  // };

  // Columns definition
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <IconButton onClick={() => handleEditClick(row)} color="error" aria-label="edit">
          <EditIcon />
        </IconButton>
      ),
      allowOverflow: true,
      button: true,
      style: {
        padding: "12px 16px", // Add padding to the actions column
      },
    },
  ];

  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div>No data found.</div>;

  return (
    <>
      {/* Confirmation Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <Grid container justifyContent="space-between" alignItems="center">
          <DialogTitle>Content List</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              <Icon>close</Icon>
            </Button>
          </DialogActions>
        </Grid>
        <DialogContent>
          <EditPage
            data={editData}
            onClose={handleClose}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
          />
        </DialogContent>
      </Dialog>
      <DataTable
        title="Content List"
        columns={columns}
        data={data}
        pagination
        responsive
        className="custom-table"
      />
    </>
  );
};

FetchTableData.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};

export default FetchTableData;
